<template>
  <div class="reservation-detail" v-loading="loading">
    <!-- 预约信息 -->
    <div class="info-card flex-between">
      <h3 class="card-title">订单信息</h3>
      <el-button @click="refresh">刷新</el-button>
    </div>
    <el-descriptions :column="3" border>
      <el-descriptions-item label="订单编号">
        {{ detail.orderNo }}
        <el-button type="text" class="ml-5" @click="$utils.copyText(detail.orderNo)">复制</el-button>
      </el-descriptions-item>
      <el-descriptions-item label="状态">
        <el-tag v-for="item in $const.TRAVELALLORDERSTATUS.filter(item => item.value === detail.status)"
          :key="item.value" :type="item.type">{{
            item.label }}</el-tag>
      </el-descriptions-item>
      <el-descriptions-item label="机构名称">
        {{ organizationName }}
      </el-descriptions-item>
      <el-descriptions-item label="线路名称">
        {{ detail.travelLineName }}
      </el-descriptions-item>
      <el-descriptions-item label="出发地">
        {{ detail.startPointName }}
      </el-descriptions-item>
      <el-descriptions-item label="目的地">
        {{ detail.endPointName }}
      </el-descriptions-item>
      <el-descriptions-item label="联系人">
        {{ detail.contactPerson }}
      </el-descriptions-item>
      <el-descriptions-item label="联系电话">
        {{ detail.contactPhone }}
        <el-button type="text" class="ml-5" @click="$utils.copyText(detail.contactPhone)">复制</el-button>
      </el-descriptions-item>
      <el-descriptions-item label="乘车人数">
        {{ detail.passengerNum }}人
      </el-descriptions-item>
      <el-descriptions-item label="用车时间">
        {{ detail.orderTime | filterTime }}
      </el-descriptions-item>
      <el-descriptions-item label="下单时间">
        {{ detail.created | filterTime }}
      </el-descriptions-item>
      <el-descriptions-item label="完成/取消时间">
        {{ detail.finishTime | filterTime }}
      </el-descriptions-item>
      <el-descriptions-item label="拼车/包车">
        {{ detail.poolType | filterConst('LYPOOLTYPE') }}
      </el-descriptions-item>
      <el-descriptions-item label="航班/班次号">
        <span v-if="detail.trafficNo && detail.trafficType">{{ detail.trafficNo }}({{ detail.trafficType }})</span>
        <span v-else>-</span>
      </el-descriptions-item>
      <el-descriptions-item label="备注">
        {{ detail.remark || '-' }}
      </el-descriptions-item>
    </el-descriptions>

    <el-tabs v-model="activeTab" @tab-click="tabClick">
      <el-tab-pane label="行程车辆" name="trip">
        <!-- <h3 class="card-title">文旅行程</h3> -->
        <div class="trip-info flex">
          <el-descriptions :column="1" style="width: 280px;">
            <el-descriptions-item label="行程编号">
              {{ detail.orderDriverVo?.orderDriverNo || '-' }}
              <el-button type="text" v-if="detail.orderDriverVo" class="ml-5"
                @click="$utils.copyText(detail.orderDriverVo.orderDriverNo)">复制</el-button>
            </el-descriptions-item>
            <el-descriptions-item label="行程状态">
              <template v-if="detail.orderDriverVo">
                <el-tag
                  v-for="item in $const.TRAVELTRIPSTATUS.filter(item => item.value === detail.orderDriverVo?.status)"
                  :key="item.value" :type="item.type">
                  {{ item.label }}
                </el-tag>
              </template>
              <span v-else>-</span>
            </el-descriptions-item>
            <el-descriptions-item label="车辆号牌">
              <span v-if="detail.orderDriverVo?.licenseNo" :style="getPlateStyle(detail.orderDriverVo.licenseNo)">{{ formatPlateNumber(detail.orderDriverVo.licenseNo) }}</span>
              <span v-else>-</span>
              <el-button v-if="detail.orderDriverVo?.licenseNo" type="text" class="ml-5"
                @click="$utils.copyText(detail.orderDriverVo.licenseNo)">复制</el-button>
            </el-descriptions-item>
            <el-descriptions-item label="车辆余座">
              <span v-if="detail.orderDriverVo?.passengerNum">乘客{{ detail.orderDriverVo?.passengerNum }} . 余座{{
                detail.orderDriverVo?.vehicleSeat - 1 - detail.orderDriverVo?.passengerNum }}</span>
              <span v-else>-</span>
            </el-descriptions-item>
            <el-descriptions-item label="值班司机">
              {{ detail.orderDriverVo?.driverName || "-" }}
            </el-descriptions-item>
            <el-descriptions-item label="联系电话">
              {{ detail.orderDriverVo?.driverPhone || "-" }}
              <el-button v-if="detail.orderDriverVo" type="text" class="ml-5"
                @click="$utils.copyText(detail.orderDriverVo.driverPhone)">复制</el-button>
            </el-descriptions-item>
            <el-descriptions-item label="车辆型号">
              <span>{{ detail.orderDriverVo?.vehicleModel || "-" }}</span><el-button class="ml-5"
                v-if="detail.orderDriverVo?.vehiclePhoto" type="text"
                @click="$utils.largeImgFn(detail.orderDriverVo?.vehiclePhoto)">查看</el-button>
            </el-descriptions-item>
            <el-descriptions-item label="完成/取消时间">
              {{ detail.orderDriverVo?.finishTime | filterTime }}
            </el-descriptions-item>
          </el-descriptions>
          <div id="map"></div>
        </div>
      </el-tab-pane>
      <el-tab-pane label="文旅商品" name="goods">
        <el-descriptions :column="3" border>
          <el-descriptions-item label="预约编号">
            {{ detail.goodsOrderNo || '-' }}
            <el-button v-if="detail.goodsOrderNo" type="text" class="ml-5"
              @click="$utils.copyText(detail.goodsOrderNo)">复制</el-button>
          </el-descriptions-item>
          <el-descriptions-item label="产品名称">
            {{ detail.goodsName || '-' }}
          </el-descriptions-item>
          <el-descriptions-item label="机构名称">
            {{ organizationName || '-' }}
          </el-descriptions-item>
        </el-descriptions>
      </el-tab-pane>
      <el-tab-pane label="操作历史" name="history">
        <el-table :data="detail.logs" border height="calc(100vh - 430px)">
          <el-table-column prop="remark" label="记录内容" />
          <el-table-column prop="operator" label="操作人" width="140" />
          <el-table-column prop="created" label="记录时间" width="180">
            <template slot-scope="scope">
              {{ scope.row.created | filterTime }}
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>

export default {
  name: 'ReservationDetail',
  data() {
    return {
      id: this.$route.query.id,
      organizationName: '',
      activeTab: 'trip',
      detail: {

      },
      map: null,
      loading: false
    }
  },

  mounted() {
    this.getDetail()
  },
  methods: {
    initMap() {
      this.map = new AMap.Map("map", {
        mapStyle: 'amap://styles/572516903e2f1273ed9c97f54ebacd89',
        resizeEnable: true,
        center: new AMap.LngLat(104.065861, 30.657401),
      });
      // 绘制上下车marker点
      let markers = this.detail.startPointLng && this.detail.startPointLat ? [
        {
          position: [this.detail.startPointLng, this.detail.startPointLat],
          stationName: this.detail.startPointName,
          type: 'start'
        },
        {
          position: [this.detail.endPointLng, this.detail.endPointLat],
          stationName: this.detail.endPointName,
          type: 'end'
        },
      ] : []
      markers.forEach(marker => {
        let content = `<div class="markerLabel ${marker.type == 'start' ? "startFC" : "endFC"}">${marker.stationName}</div>`;
        let Mark = new AMap.Marker({
          map: this.map, // 地图实例对象
          position: marker.position, // 标记位置
          // anchor: "bottom-center", // 设置锚点方位
          animation: "AMAP_ANIMATION_DROP", // 标记掉落效果
          icon:
            marker.type == 'start'
              ? require("@/assets/img/markerBegin.png")
              : require("@/assets/img/markerEnd.png"),
          offset: new AMap.Pixel(-2, 0),
        });
        Mark.setLabel({
          content: content,
          direction: "top",
          offset: new AMap.Pixel(0, -6),
        });
      });
      this.map.setFitView();
    },
    goBack() {
      this.$router.go(-1)
    },
    async getDetail() {
      this.loading = true;
      let url = "/api/v1/manage/travelOrder/order/detail";
      let params = {
        orderId: this.id
      }
      let { code, data } = await this.$axios.get(url, params)
      if (code === 1) {
        this.detail = data
        this.organizationName = await this.getOrgName(data.organizationId)
        this.initMap()
      }
      this.loading = false;
    },
    tabClick(tab) {
      if (tab.name === 'history') { /* 预留历史记录处理 */ }
    },
    refresh() {
      this.getDetail()
    }
  }
}
</script>

<style lang="less" scoped>
.reservation-detail {
  .card-title {
    margin-bottom: 16px;
  }

  .trip-info {
    height: calc(100vh - 430px);
    align-items: flex-start;

    #map {
      flex: 1;
      height: 100%;
      margin-left: 16px;
    }

    /deep/ .markerLabel {
      padding: 1rem 1.5rem;
      justify-content: center;
      align-items: center;
      border-radius: 4px;
      font-size: 1.5rem;
      color: #ffffff;
      box-shadow: 2px 2px 4px 0 rgba(0, 0, 0, 0.3);

      &.start {
        background-color: #0289ffbb;
      }

      &.startFC {
        background-color: #0289ff;
      }

      &.end {
        background-color: #228b22bb;
      }

      &.endFC {
        background-color: #228b22;
      }
    }

    :deep(.el-descriptions-item__label) {
      width: 88px;
      // text-align: right;
      font-weight: normal;
      color: #606266;
      display: flex;
      align-items: center;
      height: 30px;
    }
    :deep(.el-descriptions-item__content) {
      width: 200px;
      height: 30px;
      display: flex;
      align-items: center;
    }
  }

  :deep(.el-descriptions-item__label) {
    width: 68px;
    // text-align: right;
    font-weight: normal;
    color: #606266;
  }

  :deep(.el-descriptions-item__content) {
    width: 200px;
  }
}
</style>